import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppError } from '../../../../../models/app.model';
import swal from 'sweetalert2';
import * as messageActions from '../../../../../store/actions/messages';
import { AppMessages } from '../../../../../shared/configs/app.messages';
import * as fromRoot from '../../../../../store/reducers';
import { RestService } from '../../../../../service/rest.service';
import { select, Store } from '@ngrx/store';
import { AppUser } from '../../../../../models/user.model';
import { AppAlerts } from '../../../../../shared/configs/app.alerts';
import { getSelected } from '../../../../../store/reducers/user';

@Component({
  selector: 'app-task',
  templateUrl: './task-dialog.component.html',
  styleUrls: ['./task-dialog.component.scss']
})
export class TaskDialogComponent implements OnInit, OnDestroy {

  appError: AppError;
  user: AppUser;
  private subscriber: any;


  constructor(public dialogRef: MatDialogRef<TaskDialogComponent>,
              private store: Store<fromRoot.AppState>,
              private restService: RestService) {
    this.appError = <AppError>{};
  }

  ngOnInit() {
    this.subscriber = this.store.pipe(select(fromRoot.selectUserState()))
      .subscribe((state: any) => {
        this.user = getSelected(state);
      });
  }

  ngOnDestroy() {
    this.subscriber.unsubscribe();
  }

  save() {

    const _this = this; // reference

    swal({
      title: AppAlerts.SAVE_OBJECT_TITLE,
      type: 'warning',
      showCancelButton: true,
    }).then(function (action) {
      if (action.value === true) {
        // check object
        if (!Object.keys(_this.appError).length) {
          swal({
            title: AppAlerts.OBJECT_IS_EMPTY,
            type: 'error',
          });
          return;
        }
        if (!_this.appError.title || !_this.appError.status) {
          swal({
            title: AppAlerts.ERROR_REQUIRED_FIELDS,
            type: 'error',
          });
          return;
        }

        _this.appError.idUser = _this.user ? _this.user.id : null;

        // save
        _this.restService.addAppErrors(_this.appError)
          .subscribe( d => {
              _this.store.dispatch(new messageActions.SuccessMessage(AppMessages.APP_SAVE_SUCCESS));
              _this.dialogRef.close();
            },
            error => {
              _this.store.dispatch(new messageActions.ErrorMessage(AppMessages.APP_SAVE_ERROR));
            }
          );
      }
    });
  }

}
